var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoonly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vmSimpleHeart",
    x1: 52,
    y1: 44,
    x2: 198,
    y2: 214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ED3F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8164C"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vmSimpleShadow",
    x: 18,
    y: 24,
    width: 220,
    height: 202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 10,
    floodColor: "#A61A49",
    floodOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vmSimpleShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 213C118 204 109 196 101 189C55 150 31 127 31 89C31 57 55 34 85 34C104 34 119 43 128 57C137 43 152 34 171 34C201 34 225 57 225 89C225 127 201 150 155 189C147 196 138 204 128 213Z",
    fill: "url(#vmSimpleHeart)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 213C118 204 109 196 101 189C55 150 31 127 31 89C31 57 55 34 85 34C104 34 119 43 128 57C137 43 152 34 171 34C201 34 225 57 225 89C225 127 201 150 155 189C147 196 138 204 128 213Z",
    stroke: "rgba(255,255,255,0.34)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 61C97 47 114 41 131 44",
    stroke: "#FFD6E4",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoonly);
export default __webpack_public_path__ + "static/media/logoonly.df14b273a6b136a24ca1bf49e11c4955.svg";
export { ForwardRef as ReactComponent };